import { logger } from './logger'
import { Config } from './config'

export enum bidForceEnum {
  ad = 'ad',
  error = 'error',
  none = 'none'
}
export type bidForceValues = keyof typeof bidForceEnum
export type bidForceOptions = bidForceValues | null

function isBidForceType(toTest: string | null): toTest is bidForceValues {
  return !!toTest && toTest in bidForceEnum
}

export function bidForceGuard(
  maybeBidForceValue: string | null
): bidForceOptions {
  return isBidForceType(maybeBidForceValue) ? maybeBidForceValue : null
}

export function bidForceLog(...args): void {
  logger.log(`BID FORCE LOG:`, ...args)
}

export function bidForceStatus(config: Config, ...args): void {
  const forcing = config.nextBidForce
  if (forcing) {
    logger.log(`BID FORCE LOG (forcing ${forcing}):`, ...args)
  }
}
